let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cA2vu")).then(() => parcelRequire('78pH2'));